import { range, map } from 'lodash';

export const getLimitArray = (limit: number | null) => {
  if (!limit) return [];

  return map(range(1, limit + 1), (value) => ({ value: `${value}` }));
};
